import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { Banner, Button } from "@shopify/polaris";
import utils from '../../../../../utils/utils'
import "./index.css";

import intl from '../../../../../i18n/intl'

class ProductReplaceSourceBanner extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
  }

  // 组件渲染完成，再次修改渲染内容
  UNSAFE_componentWillReceiveProps(nextProps) {
    // this.setState({
    // });
  }

  render() {

    const pageContent = (this.props.show && this.props.id) && (
      <div className="ProductReplaceSourceBanner">
        <Banner
          tone="info"
        >
          <div className='ProductReplaceSourceContent'>
            <div>
              {intl.get('We have found a more profitable source of this item, you can consider to change the source of it, and the product will be shipped by Dropshipman.')}
            </div>
            <div>
              <Button
                onClick={() => {
                  utils.routeListen('/admin/supplier')
                  utils.routeJump(this,'/admin/supplier?supplier='+this.props.id)}}
                // url={'/admin/supplier/' + this.props.id}
                // external
              >
                {intl.get('View items')}
              </Button>
            </div>
          </div>
        </Banner>
      </div>
    )

    return (
      <>
        {pageContent}
      </>
    );
  }
}

export default withRouter(ProductReplaceSourceBanner);